import { RouteNames } from '@/router/constants/routeName';

export type NavigationLink = {
  name: string;
  icon: string;
  route: RouteNames;
  path: string;
};

export const SIDEBAR_GENERAL_LINKS: NavigationLink[] = [
  {
    name: 'Devices',
    icon: 'bi-hdd',
    route: RouteNames.Devices,
    path: '/devices',
  },
  {
    name: 'Machines',
    icon: 'bi-cpu',
    route: RouteNames.Machines,
    path: '/machines',
  },
];

export const SIDEBAR_CONFIGURATION_LINKS: NavigationLink[] = [
  {
    name: 'Templates',
    icon: 'bi-file-earmark-text',
    route: RouteNames.Templates,
    path: '/templates',
  },
  {
    name: 'Template Archive',
    icon: 'bi-archive',
    route: RouteNames.TemplateArchive,
    path: '/template-archive',
  },
  {
    name: 'Data Models',
    icon: 'bi-diagram-3',
    route: RouteNames.DataModels,
    path: '/data-models',
  },
  {
    name: 'Namespaces',
    icon: 'bi-folder',
    route: RouteNames.Namespaces,
    path: '/namespaces',
  },
];

export const SIDEBAR_DIAGNOSTICS_LINKS: NavigationLink[] = [
  {
    name: 'Runtime Errors',
    icon: 'bi-exclamation-triangle',
    route: RouteNames.ErrorLogs,
    path: '/runtime-errors',
  },
  {
    name: 'Metrics',
    icon: 'bi-bar-chart',
    route: RouteNames.Metrics,
    path: '/metrics',
  },
  {
    name: 'ADS Explorer',
    icon: 'bi-search',
    route: RouteNames.ExploreAdsVariables,
    path: '/explore-ads-variables',
  },
];

export const USER_MENU_LINKS: NavigationLink[] = [
  {
    name: 'Users',
    icon: 'bi-people',
    route: RouteNames.Users,
    path: '/users',
  },
  {
    name: 'Fleet Controls',
    icon: 'bi-truck',
    route: RouteNames.FleetControls,
    path: '/fleet-controls',
  },
  {
    name: 'Endpoint Tags',
    icon: 'bi-tags',
    route: RouteNames.EndpointTags,
    path: '/endpoint-tags',
  },
];

export const APP_NAME = 'Edge Telemetry Service';
